import React from 'react';
import { Clock } from '@phosphor-icons/react';

export const InboxStatusStrip = ({ status }) => {
  if (!status) return null;
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-6" data-testid="inbox-status-strip">
      <div className="bg-white border border-[#E5E7EB] rounded-lg p-3" data-testid="inbox-status-pending">
        <p className="text-xs font-bold tracking-[0.12em] uppercase text-[#6B7280] font-ibm">Pending</p>
        <p className="font-outfit text-2xl font-bold text-amber-600">{status.pending}</p>
      </div>
      <div className="bg-white border border-[#E5E7EB] rounded-lg p-3" data-testid="inbox-status-assigned">
        <p className="text-xs font-bold tracking-[0.12em] uppercase text-[#6B7280] font-ibm">Assigned</p>
        <p className="font-outfit text-2xl font-bold text-green-600">{status.assigned}</p>
      </div>
      <div className="bg-white border border-[#E5E7EB] rounded-lg p-3" data-testid="inbox-status-total">
        <p className="text-xs font-bold tracking-[0.12em] uppercase text-[#6B7280] font-ibm">Total Received</p>
        <p className="font-outfit text-2xl font-bold text-[#09090B]">{status.total}</p>
      </div>
      <div className="bg-white border border-[#E5E7EB] rounded-lg p-3" data-testid="inbox-status-last">
        <p className="text-xs font-bold tracking-[0.12em] uppercase text-[#6B7280] font-ibm flex items-center gap-1"><Clock size={12} /> Last Received</p>
        <p className="font-ibm text-sm text-[#09090B] mt-1.5">{status.last_received_at ? new Date(status.last_received_at).toLocaleString() : '—'}</p>
      </div>
    </div>
  );
};
